const AboutSection = () => {
  return (
    <section className="about" id="studio">
      <div className="wrap about-grid reveal">
        <div className="about-left">
          <div className="kicker">03 — About ODDA</div>
          <h2>
            Designed
            <br />
            with
            <br />
            <span className="accent">intention.</span>
          </h2>
        </div>
        <div className="about-copy">
          <p>
            <strong>ODDA Corp.</strong> is an architecture, design, and development practice creating spaces of enduring character.
          </p>
          <p>
            Our work is defined by{" "}
            <strong>quiet luxury, sculptural form, natural materials, refined proportions, and an enduring sense of place.</strong>{" "}
            We create architecture that is not simply seen, but experienced — timeless, considered, and unmistakably ODDA.
          </p>
          <p>
            Led by <strong>Kwesi Addo</strong>, whose fifteen years across Toronto’s architecture practices — and the residential portfolio of NK Design Group, now merged into ODDA — sit behind every project the studio takes on.
          </p>
          <div className="about-mark">
            Architecture · Design · Development <b>— ODDA Corp.</b>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
